import { useEffect, useMemo } from 'react';
import { useAllProducts } from './useAllProducts';
import { useCartStore } from '../context/cart/CartStore';
import { buildBundleDefinitions } from '../utils/bundleDetection';

/**
 * Initializes bundle definitions in the cart store whenever the menu products change.
 * Should be called once in a component that has access to the menu context (e.g. Menu page).
 */
export function useBundleDefinitions(): void {
  const allProducts = useAllProducts();
  const setBundleDefinitions = useCartStore((state) => state.setBundleDefinitions);

  const definitions = useMemo(() => buildBundleDefinitions(allProducts), [allProducts]);

  useEffect(() => {
    setBundleDefinitions(definitions);
  }, [definitions, setBundleDefinitions]);
}
